import {
  createFilterOptions,
  Autocomplete as MuiAutocomplete,
  TextField,
} from "@mui/material";
import { useState } from "react";

import { SortCarrier } from "../../types/rfpApi";

const MIN_CHARS_BEFORE_SEARCH = 3;

const filterOptions = createFilterOptions<SortCarrier>({ limit: 100 });

const DrawerAutocomplete = ({
  carriers,
  onSelectCarrier: onSelect,
}: {
  carriers: SortCarrier[];
  onSelectCarrier: (carrier: SortCarrier) => void;
}): React.JSX.Element => {
  const [inputValue, setInputValue] = useState("");
  return (
    <MuiAutocomplete
      disablePortal
      options={carriers}
      inputValue={inputValue}
      value={null}
      clearOnBlur
      onChange={(_, option, reason) => {
        if (reason === "selectOption" && option) {
          onSelect(option);
          setInputValue("");
        }
      }}
      onInputChange={(_, newInputValue, reason) => {
        if (reason === "input") {
          setInputValue(newInputValue);
        }
      }}
      getOptionLabel={(option) => option.name}
      filterOptions={(options, state) => {
        if (state.inputValue.length < MIN_CHARS_BEFORE_SEARCH) {
          return [];
        }

        return filterOptions(options, state);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={`Search for carrier name: at least ${MIN_CHARS_BEFORE_SEARCH} letters required`}
        />
      )}
    />
  );
};

export { DrawerAutocomplete };
